import script from "./work_report.vue?vue&type=script&setup=true&lang=js"
export * from "./work_report.vue?vue&type=script&setup=true&lang=js"

import "./work_report.vue?vue&type=style&index=0&id=0ebc829c&lang=css"

const __exports__ = script;

export default __exports__